import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import commonDe from './translations/common/de.json';
import commonEn from './translations/common/en.json';
import commonNl from './translations/common/nl.json';
import commonPt from './translations/common/pt.json';

export const DEFAULT_LOCALE = 'en';

const resources = {
  de: {
    common: commonDe,
  },
  en: {
    common: commonEn,
  },
  nl: {
    common: commonNl,
  },
  pt: {
    common: commonPt,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: DEFAULT_LOCALE,
  fallbackLng: DEFAULT_LOCALE,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
